import { Component, OnInit } from '@angular/core';
import { GTopicService } from './g-topic.service';

export class GeneralComponent implements OnInit {

  protected configuration: any;
  protected state: any;

  constructor(protected topicService: GTopicService) {}

  ngOnInit(){};

  /** get text in right language 
  * @param {string} tag - text to load
  */
 get(tag:string):string {
	return this.topicService.get(tag);
  }

  /** returns an array containing number 0 to size -1
   * @param {number} size - size of array
   */
  createArray(size: number): number[] {
    if(size < 0){
      return [];
    }
    return Array.from(Array(size).keys());
  }

  /**
   * converts the charCode into a char
   * @param i  - charCode to convert
   */
  fromCharCode(i: number): string {
    return String.fromCharCode(i);
  }

}
